export default __webpack_public_path__ + "static/unicef-dark.bbaf98df.svg";